<template lang="html">
  <div class="checkbox" :class="{ disabled }">
    <input
      :id="name"
      :checked="value"
      :disabled="disabled"
      type="checkbox"
      @change="$emit('input', $event.target.checked)"
    />
    <label :for="name">{{ label }}</label>
  </div>
</template>

<script>
import { kebabCase } from 'lodash';

export default {
  name: 'Checkbox',

  props: {
    label: {
      type: String,
      required: true,
    },

    value: {
      type: Boolean,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    name() {
      return kebabCase(this.label.toLowerCase());
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox {
  &.disabled {
    opacity: map-get($app, 'disabled-opacity');
  }
}

[type='checkbox'] {
  margin-right: 0.5em;
}
</style>
